import { call, put, takeLatest } from "redux-saga/effects";
import { Action } from "../../../actions/actions";
import { API } from "../../../api/api";
import { ConfigurationsActionTypes } from "../actions/actionTypes";
import { configurationsAPI } from "../api/api";

function* getDenominations(action: Action) {
    try {
        const denominations = yield call(() =>
            configurationsAPI.getDenominations({
                countryId: action.payload.countryId
            })
        );

        yield put({
            type: ConfigurationsActionTypes.GET_DENOMINATIONS_SUCCESS,
            payload: denominations.data
        });
    } catch (e) {
        API.handleError(e.response, "Error getting Denominations.");

        yield put({
            type: ConfigurationsActionTypes.GET_DENOMINATIONS_FAIL,
            payload: e
        });
    }
}

export function* getDenominationsWatcher() {
    yield takeLatest(
        ConfigurationsActionTypes.GET_DENOMINATIONS,
        getDenominations
    );
}
